import type { LoyaltyPointsSpending } from '~~/types/loyaltyPoints/loyaltyPoints';

export const formatLoyaltySpendings = (
  spendings: readonly LoyaltyPointsSpending[],
  formatAmount: (spending: LoyaltyPointsSpending) => string,
): string => spendings
  .filter(({ amount }) => amount > 0)
  .map(formatAmount)
  .join(' + ');
